import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'AccuraCore',
  brandName: 'AccuraCore',
  description: 'Sistema de agendamento para contabilistas',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Escritório de contabilidade',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Contabilista trabalhando',
  },
  testimonials: [
    {
      name: 'Carlos Mendes',
      role: 'Contabilista Certificado',
      text: 'Desde que usamos o AccuraCore, a organização dos nossos clientes melhorou 90%. Fantástico!',
      image: testimonial1,
    },
    {
      name: 'Sofia Rodrigues',
      role: 'Gestora de Contas',
      text: 'A funcionalidade de agendamento online poupa-nos horas de trabalho administrativo por semana.',
      image: testimonial2,
    },
    {
      name: 'Pedro Alves',
      role: 'CEO, Alves & Associados',
      text: 'Os nossos clientes adoram a facilidade de marcar reuniões. Recomendo a 100%!',
      image: testimonial3,
    },
  ],
  terminology: {
    professional: 'contabilista',
    professionals: 'contabilistas',
    business: 'escritório',
    businesses: 'escritórios',
    service: 'consulta',
    services: 'consultas',
    client: 'cliente',
    clients: 'clientes',
    appointment: 'reunião',
    appointments: 'reuniões',
  },
  homepage: {
    hero: {
      badge: 'Solução Completa',
      title: 'Simplifique seus agendamentos com AccuraCore',
      description: 'Aumente a produtividade e ofereça a melhor experiência aos seus clientes com o AccuraCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Agendar Demonstração',
      features: ['Sem cartão de crédito', 'Configuração em 5 minutos'],
    },
    statistics: [
      { value: '300+', label: 'Escritórios' },
      { value: '25k+', label: 'Reuniões' },
      { value: '99%', label: 'Satisfação' },
    ],
    painPoints: [
      {
        title: 'Marcações por Telefone',
        description: 'Interromper consultas para atender chamadas resulta em clientes insatisfeitos e perda de concentração.',
        icon: 'PhoneCall',
        quote: {
          text: 'Perdemos em média 20 minutos por dia apenas atendendo chamadas para agendamentos',
          author: 'Ana Ferreira',
          business: 'Ferreira Contabilidade',
        },
      },
      {
        title: 'Tempo Perdido',
        description: 'Gerir horários manualmente consome tempo que poderia usar para atender mais clientes.',
        icon: 'Clock',
        stats: [
          { label: 'Tempo perdido por semana:', value: '6 horas' },
          { label: 'Clientes perdidos por mês:', value: '15+' },
        ],
      },
      {
        title: 'Clientes Ausentes',
        description: 'Faltas e cancelamentos de última hora causam prejuízos e horários vazios que poderiam ser preenchidos.',
        icon: 'Users',
        quote: {
          text: 'Reduzimos as faltas em 85% após implementar o sistema de agendamento online',
          author: 'João Santos',
          business: 'Santos & Associados',
        },
      },
    ],
    solution: {
      badge: 'A Solução',
      title: 'AccuraCore: O seu assistente digital',
      description: 'Simplificamos a gestão do seu escritório para que possa focar-se no que realmente importa.',
      features: [
        {
          title: 'Agendamento Online 24/7',
          description: 'Os seus clientes podem marcar reuniões a qualquer momento, sem precisar telefonar.',
        },
        {
          title: 'Gestão de Clientes',
          description: 'Aceda ao histórico de consultas e documentos de cada cliente.',
        },
        {
          title: 'Lembretes Automáticos',
          description: 'Reduza as faltas com lembretes por email ou SMS.',
        },
      ],
    },
    testimonials: {
      title: 'O que os nossos clientes dizem',
      description: 'Contabilistas que confiam no AccuraCore para crescer.',
    },
    finalCta: {
      title: 'Pronto para simplificar seus agendamentos?',
      description: 'Junte-se a contabilistas que já estão a crescer com o AccuraCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Falar com Consultor',
    },
    contact: {
      title: 'Fale Conosco',
    },
  },
  auth: {
    register: {
      title: 'Criar uma conta',
      description: 'Preencha os dados abaixo para se registrar',
      inviteDescription: 'Crie sua conta para aceitar o convite de contabilista',
      subscriptionDescription: 'Crie sua conta para finalizar sua assinatura',
      inviteCodeLabel: 'Você está usando um código de convite',
      subscriptionLabel: 'Você selecionou um plano de assinatura',
    },
    login: {
      title: 'Entrar na conta',
      description: 'Digite suas credenciais para acessar',
    },
  },
}

export default config
